export const useGeneralReviews = async () => {
  const { data: filterOptions } = await useFetchSafely(() => "pages/customer-reviews");
  return filterOptions.value.data;
};

export const useReviewsList = async (page = 1) => {
  const { data } = await useFetchSafely(() => `customer-reviews/reviews`, {
    params: {
      page,
    },
  });

  const rawData = toRaw(data.value);
  return {
    list: rawData?.data ?? [],
    canLoadMore: page * (rawData?.meta?.per_page ?? 0) < (rawData?.meta?.total ?? 0),
  };
};
